/* eslint-disable tailwindcss/no-custom-classname */
/* eslint-disable tailwindcss/no-arbitrary-value */
import classNames from 'classnames';
import type { EnumProductBlockColorTag } from '../../../types/cmsEnums';
import { tagColor as getTagColor } from '../../Tag';

type ProductGridCardTagProps = {
  tagColor?: EnumProductBlockColorTag;
  tagText?: string;
  isPreviewCard: boolean;
};

export const ProductGridCardTag = ({
  tagColor,
  tagText,
  isPreviewCard,
}: ProductGridCardTagProps) => {
  const hasTagText = Boolean(tagText);

  return (
    <div
      className={classNames(
        'flex w-full items-center rounded-[4px] px-[6px] py-[2px] md:rounded-[6px] md:px-spacing/padding/soft-8px md:py-spacing/padding/soft-4px lg:rounded-radius/tooltip',
        getTagColor(tagColor?.toLowerCase()),
        { invisible: !hasTagText },
      )}
    >
      <p
        className={classNames(
          'truncate text-left',
          isPreviewCard
            ? 'mhg-alpha-caption'
            : 'mhg-alpha-caption text-[10px] leading-[16px] md:mhg-alpha-caption',
        )}
        title={hasTagText ? tagText : undefined}
      >
        {hasTagText ? tagText : '\u00A0'}
      </p>
    </div>
  );
};
